import React from 'react';
import InstructionWrap from '../../../../components/InstructionWrap';
import StepItemVisa from '../../../../components/StepItemVisa';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getVisaServiceId } from '../function';

const Tourist = ({ i18n, visaServiceList }) => {
  const visaServiceId = getVisaServiceId(visaServiceList, 'tourist');

  return (
    <div className='card-instruction-detail'>
      <div className='title'>{i18n('visa_page.tab3.title')}</div>
      <main>
        <StepItemVisa
          instructions={i18n('visa_page.tab3.step.instruction2')}
          i18n={i18n}
          type='tourist'
          serviceId={visaServiceId}
        />
        <InstructionWrap
          instruction={i18n('visa_page.tab3.step.instruction1')}
          instructionList={i18n('visa_page.instruction_step.tourist_req')}
          type='number'
        />
      </main>
    </div>
  );
};

Tourist.propTypes = {
  i18n: PropTypes.func,
  visaServiceList: PropTypes.array
};

const mapStateToProps = (state) => ({
  i18n: state.langReducer.i18n
});

export default connect(mapStateToProps)(Tourist);
